export default __webpack_public_path__ + "static/media/banner.96664f08.PNG";